import { url, header } from "../../apis/Index";
import { toast } from "react-toastify";
import axios from "axios";

export const getBeneficiries = () => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BENEFICIARY_INFO",
      fetchingBeneficiriesLoaders: true,
    });

    axios
      .get(`${url}/beneficiaries`, {
        headers: header,
      })
      .then((beneficiaries) => {
        dispatch({
          type: "GET_BENEFICIARIES",
          beneficiaries,
        });

        dispatch({
          type: "GETTING_BENEFICIARY_INFO",
          fetchingBeneficiriesLoaders: false,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GETTING_BENEFICIARY_INFO",
          fetchingBeneficiriesLoaders: false,
        });
        dispatch({
          type: "GET_BENEFICIARY_FAILED",
          fetchingBeneficiriesErroredMessage: error.message,
        });
      });
  };
};

export const createBeneficiary = (newBeneficiary, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_BENEFICIARY_INFO",
      loader: true,
    });
    axios
      .post(`${url}/beneficiaries`, newBeneficiary, {
        headers: header,
      })
      .then((beneficiary) => {
        dispatch({
          type: "CREATE_BENEFICIARY",
          beneficiary,
        });

        dispatch({
          type: "SENDING_BENEFICIARY_INFO",
          loader: false,
        });

        closeFormAfterAdding();
        toast.success("Beneficiary registered", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        dispatch({
          type: "SENDING_BENEFICIARY_INFO",
          loader: false,
        });
        dispatch({
          type: "REGISTER_BENEFICIARY_FAILED",
          registerBenActionFailedMessage: "Registration failed",
        });
      });
  };
};

export const updateBeneficiary = (
  updateBeneficiary,
  id,
  closeFormAfterAdding
) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_BENEFICIARY_INFO",
      loader: true,
    });
    axios
      .put(`${url}/beneficiaries/${id}`, updateBeneficiary, {
        headers: header,
      })
      .then((beneficiary) => {
        dispatch({
          type: "UPDATE_BENEFICIARY",
          beneficiary,
        });
        dispatch({
          type: "SENDING_BENEFICIARY_INFO",
          loader: false,
        });
        closeFormAfterAdding();
      })
      .catch((error) => {
        dispatch({
          type: "REGISTER_BENEFICIARY_FAILED",
          registerBenActionFailedMessage: "Updating failed",
        });
      });
  };
};

export const deleteBeneficiary = (id) => {
  return (dispatch) => {
    dispatch({
      type: "DELETING_BENEFICIARY_INFO",
      deletingBen: {
        id: id,
        deleting: true,
      },
    });
    axios
      .delete(`${url}/beneficiaries/${id}`, {
        headers: header,
      })
      .then(() => {
        dispatch({
          type: "DELETE_BENEFICIARY",
          id,
        });
        dispatch({
          type: "DELETING_BENEFICIARY_INFO",
          deletingBen: {
            id: null,
            deleting: false,
          },
        });
      })
      .catch((error) => {
        toast.error("Failed to delete beneficiary", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
        dispatch({
          type: "DELETING_BENEFICIARY_INFO",
          deletingBen: {
            id: id,
            deleting: false,
          },
        });
      });
  };
};
